// Integrates with the 'Wishlist Engine' app
var wishlistElemsOnPage = [];
var wishlistArray = [];


// Load if we're on wishlist
$(document).ready(function() {
  
  if (window.location.href.indexOf("wishlist") > -1) {
      
    console.log('is wishlist page');

    // First we need to wait till the Wishlist is created by the app.
    const wishListObj = wishlistPageObserver();
    
    
  }
});



function wishlistPageObserver() {
  
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector(".wishlist-page");
  
  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    
    for (const mutation of mutationList) {

      if (mutation.type === "childList") {

        // Some other elements on the page can trigger the mutation listener, and therefore the removal. Skips listed as 'skippableClasses' variable.
        function checkSkippableMutations(mutant) {
          let passable = true;
          let skippableClasses = ['klaviyo','needsclick'];
          skippableClasses.forEach( (thisSkipClass)=>{
             if(mutant.classList.contains(thisSkipClass)) {
               passable = false;
             }
          });
          return passable; // if loop has none of the flagged classes, pass.
        }

        if(checkSkippableMutations(mutation.target)) {
        
          console.log("Finished listening for dom change in wishlist page");
          
          reKickScrollHeight(); // Recalc height
  
          generateExtraWishlistData(mutation.target);
  
          buildEnquiryForm();    
  
          newSideHeading();
          
          observer.disconnect();
          
        }
        
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

}

function reKickScrollHeight() {
  let heightForcer = document.getElementById('js-height-forcer');
  let siteWrap = document.getElementsByClassName('c-site-wrapper')[0];
  let wrapHeight = siteWrap.clientHeight;
  heightForcer.style.height = wrapHeight + 'px';
}

function generateExtraWishlistData(wishListObj) {

    //Get the wishlist items. Then fetch their data from shopify.
    if(wishListObj.classList.contains('wishlist-page')) {

      // We have a wishlist, lets go...
      let wishListingAll = wishListObj.querySelectorAll('.wh-list-column');
      wishlistElemsOnPage.push(wishListingAll);
      
      if(wishListingAll.length > 0) {

          wishListingAll.forEach( (wishListing)=>{
            let moveToCartButton = wishListing.querySelector('.wishlist-move-cart');
            if(moveToCartButton) {
              
              moveToCartButton.addEventListener('click',()=>{
                console.log('moving wishlist item to cart');
                setTimeout(()=>{
                  location.reload();
                },500);
              });
            }
          });
          
       
      }
    }
}

function buildEnquiryForm() {
  
  let wlleft = document.querySelector('.wishlistajaxLoad'); // Wishlist left is the initial app's output.

  if(wlleft) {
    
    //Make sure left has products first
    let prodlisting = wlleft.querySelectorAll('.wh-list-column');
    if(prodlisting.length > 0) {
    

      let wlright = document.createElement("div");
      wlright.classList.add('wh-list-layout','wishlist-newright','enquiryForm');
      insertAfter(wlleft,wlright);

      fetch('/?section_id=wishlist-enquiry-form')
      .then(response => response.text())
      .then(data => {
        wlright.innerHTML = data;
        wlCheckSubmitted();
        wlPopulateProducts();
      });

      function wlPopulateProducts() {
        let prodMeta = document.querySelectorAll('.wh-pro-meta');
        let hiddenProductsFieldInForm = document.querySelector('#hiddenEnquiryProductsForm');

        let prodListing = '';
        if(prodMeta.length > 0) {
          prodMeta.forEach((item)=>{
            let title = item.querySelector('h3 a').textContent;  
            let variant = item.querySelector('.wishlist-variant').textContent;
            prodListing += title;
            if(variant) {
              prodListing += ' (' + variant + ')'
            }
            prodListing += ' \n';
          });
          if(hiddenProductsFieldInForm) {
            hiddenProductsFieldInForm.innerHTML = prodListing;
          }
        }
      
      }

      function wlCheckSubmitted() {
        let isSubmitCheck = false;
        if (window.location.href.indexOf("contact_posted=true") > -1) {
         isSubmitCheck = true;
        }
        setTimeout(()=>{
          let thisarea = document.querySelector('.enquirychecking');
          if(isSubmitCheck) {
            thisarea.classList.add('hassubmitted');
          }
          thisarea.classList.remove('enquirychecking');
        },1000);
      }
    
    }
  }
}

function newSideHeading() {

  const newHeading = document.createElement('div');
  newHeading.classList.add('newHeading','lyformtitle');
  newHeading.textContent = 'Your Products';

  let wlCols = document.querySelectorAll('.wh-list-column');
  if(wlCols.length > 0) {
    const newSibling = wlCols[0];
    const parentElement = newSibling.parentNode;
    parentElement.insertBefore(newHeading, newSibling);
  }

}

function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}